<section class="flex flex-col gap-6 py-6">
	<h3>You’re Almost There!</h3>
	<p class="p-sm">
		To start using Sync, you'll have to make sure that you're setup to receive
		your mortgage instructions through the fax number listed on your LSO
		profile. Go through our step-by-step guide to reroute your instructions to
		your fax number and begin processing mortgages through Sync!
	</p>
	<div class="p-sm">
		<p>In these final steps, we'll assist you with:</p>
		<ul class="list-inside list-disc pl-2">
			<li>Verifying your fax information</li>
			<li>Rerouting instructions from other platforms (if necessary)</li>
			<li>Uploading instructions to Sync for digital processing</li>
		</ul>
	</div>
	<div class="self-center">
		<img
			src="/assets/images/undraw/undraw_through_the_park_04C8B6.svg"
			class="w-[400px]"
		/>
	</div>
</section>
